var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    fill: "#313131"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.19171 8.26222C8.57758 7.67046 7.52237 8.09174 7.52237 8.92824C7.52237 9.76474 8.57711 10.1864 9.19171 9.59426C9.57366 9.22669 9.57366 8.62984 9.19171 8.26222ZM8.87277 4.6225C8.87277 5.09469 8.12825 5.09469 8.12825 4.6225V3.30727C8.12825 2.83508 8.87277 2.83508 8.87277 3.30727V4.6225ZM4.93737 5.24929C5.28394 5.58324 4.75754 6.09046 4.41097 5.75652L3.49922 4.87798C3.15264 4.54403 3.67904 4.0368 4.02562 4.37075L4.93737 5.24929ZM12.9753 4.37075C13.3219 4.0368 13.8483 4.54403 13.5017 4.87798L12.59 5.75698C12.2434 6.09093 11.717 5.58371 12.0636 5.24976L12.9753 4.37075ZM5.03043 6.88822C7.11707 5.74908 9.88333 5.74908 11.9701 6.88822C13.0016 7.45149 13.7155 8.20106 14.0302 8.86896C14.0486 8.90773 14.0486 8.94836 14.0302 8.98759C13.7156 9.65548 13.0021 10.4051 11.9701 10.9683C9.88345 12.1075 7.11719 12.1075 5.03043 10.9683C3.99896 10.4051 3.28553 9.65549 2.97085 8.98759C2.95243 8.94883 2.95243 8.90819 2.97085 8.86896C3.28543 8.20108 3.99893 7.4515 5.03043 6.88822ZM8.50051 7.26888C10.0298 7.26888 10.8005 9.05914 9.71811 10.102C8.63574 11.1449 6.77788 10.4023 6.77788 8.92876C6.77836 8.01192 7.54949 7.26888 8.50051 7.26888Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewIcon);
export default __webpack_public_path__ + "static/media/view-icon.dce87ba0500aab8e82ebe07f272ff13a.svg";
export { ForwardRef as ReactComponent };